import React from 'react';
import cn from 'classnames';

import { useGilt } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';

import CN from './CashupTableRow.module.scss'; // common for deposit, cash and voucher tabs

const STYLE_PAID = Object.freeze({ textTransform: 'capitalize' });

const VoucherSoldItem = ({ amount, codeNumber, date, paid, purchasedBy, soldBy }) => {
  const { isDarkMode } = useTheme();
  const { formatDate } = useGilt();

  const displayTime = formatDate(date, { hideDate: true });
  const displayDate = formatDate(date, { hideTime: true, hideWeekday: true });

  return (
    <div
      data-bem="VoucherSoldItem"
      className={cn({
        [CN.tableRow]: true,
        [CN.medWidth]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <div className={CN.fixedColumnCell}>
        <span>{displayTime} </span>
        <span>{displayDate}</span>
      </div>

      <div className={CN.cell}>
        <span>{codeNumber}</span>
      </div>
      <div className={CN.cell}>
        <span>{purchasedBy}</span>
      </div>
      <div className={CN.cell}>
        <span>{soldBy}</span>
      </div>
      <div className={CN.cell}>
        <span>{amount}</span>
      </div>
      <div className={CN.cell}>
        <span style={STYLE_PAID}>{paid}</span>
      </div>
    </div>
  );
};
export default VoucherSoldItem;
